import "./userAddresses.css";

const UserAddresses = () => {
  return <div>UserAddresses</div>;
};

export { UserAddresses };
